import { useState, useEffect } from 'react';
import { useLanguage } from '../hooks/useLanguage';

export const DateTimePicker = ({ label, value, onChange, name, required = false }) => {
  const { t, language } = useLanguage();
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  // Parse the datetime value into separate date and time
  useEffect(() => {
    if (value) {
      const dateObj = new Date(value);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');

      setDate(`${year}-${month}-${day}`);
      setTime(`${hours}:${minutes}`);
    }
  }, [value]);

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setDate(newDate);
    if (newDate && time) {
      const combined = `${newDate}T${time}`;
      onChange({ target: { name, value: combined } });
    }
  };

  const handleTimeChange = (e) => {
    const newTime = e.target.value;
    setTime(newTime);
    if (date && newTime) {
      const combined = `${date}T${newTime}`;
      onChange({ target: { name, value: combined } });
    }
  };

  // Generate time options in 30-minute intervals
  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const h = String(hour).padStart(2, '0');
        const m = String(minute).padStart(2, '0');
        options.push(`${h}:${m}`);
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 mr-1">*</span>}
        </label>
      )}
      <div className={`grid grid-cols-2 gap-2 ${language === 'he' ? 'direction-rtl' : ''}`}>
        <div>
          <label className="block text-xs text-gray-500 mb-1">
            {t('date') || 'תאריך'}
          </label>
          <input
            type="date"
            value={date}
            onChange={handleDateChange}
            required={required}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-500 mb-1">
            {t('time') || 'שעה'}
          </label>
          <select
            value={time}
            onChange={handleTimeChange}
            required={required}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">{t('selectTime') || 'בחר שעה'}</option>
            {timeOptions.map((timeOption) => (
              <option key={timeOption} value={timeOption}>
                {timeOption}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};
